import { executeCommand } from 'core/utils/deviceUtils';
import { connect } from 'react-redux';
import { cancelCommand, fetchHistory } from '../status/redux/actions';
import {
  addCustomFrequency,
  changeCustomTypeValue,
  changeDropdown,
  changeScanType,
  clearListCustomFrequencies,
  deleteCustomFrequency,
  startScan,
  toggleScanAccordion
} from './redux/actions';
import RfTuningScanComponent from './rf-tuning-scan-component';

const mapStateToProps = (state: any, ownProps: any) => ({
  id: ownProps.id,
  results: state.devices.detail.rfTuning.scan.results,
  lastResultDate: state.devices.detail.rfTuning.scan.lastResultDate,
  form: state.devices.detail.rfTuning.scan.form,
  waitingCommandExecution: state.devices.detail.rfTuning.scan.waitingCommandExecution,
  activityLog: state.devices.detail.rfTuning.scan.activityLog,
  scan: state.devices.detail.rfTuning.scan,
  t: state.i18n.t,
  frequencyLimits: state.devices.detail.rfTuning.status.frequencyLimits,
  general: state.devices.detail.general,
  offset: state.application.offset,
});

export default connect(mapStateToProps, {
  startScan,
  changeScanType,
  changeCustomTypeValue,
  cancelCommand,
  addCustomFrequency,
  deleteCustomFrequency,
  clearListCustomFrequencies,
  changeDropdown,
  fetchHistory: fetchHistory,
  toggleScanAccordion,
  executeCommand,
})(RfTuningScanComponent);
